export default {
  hideLoad(state) {
    state.hideLoad = true
    setTimeout(()=>{
      state.showhideLoad = true
    },2000)
  },
  shownav(state) {
    state.shownav = true
  }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js